import axios from 'axios';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { signAsset } from '../../api/assets';
import { notifyUser } from '../../store/Toast';

const uploadAxios = axios.create({
  withCredentials: false,
});

interface FileUpload {
  file: File | null;
  resource?: string;
  resourceId?: number | string | undefined;
  applyData?: any;
  customSign?: any;
  path?: string;
  dispatchNotification?: boolean;
}

export default function useUpload() {
  const [error, setError] = useState(false);
  const [isUploadSuccess, setIsUploadSuccess] = useState(false);
  const [isUploading, setisUpoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<undefined | { key: string; type: string; size: number }>(undefined);
  const dispatch = useDispatch();

  const uploadFile = useCallback(
    async ({ file, resource, resourceId, applyData, customSign, path, dispatchNotification = true }: FileUpload) => {
      setisUpoading(true);
      setError(false);
      setIsUploadSuccess(false);
      if (!file) {
        setisUpoading(false);
        return;
      }

      try {
        const signResponse = customSign
          ? customSign
          : await signAsset({
              key: file.name,
              type: file.type,
              resource,
              resourceId,
              path,
            });

        const { url, fKey } = signResponse;
        const options = {
          headers: {
            'Content-Type': file.type,
          },
        };

        await uploadAxios.put(url, file, options);

        if (applyData) {
          applyData({
            key: fKey,
            type: file.type,
            size: file.size,
          });
        }

        setUploadedFile({
          key: fKey,
          type: file.type,
          size: file.size,
        });
        setIsUploadSuccess(true);

        if (dispatchNotification) {
          dispatch(
            notifyUser({
              showToast: true,
              toastMessage: 'Upload successful',
              toastType: 'success',
            })
          );
        }
      } catch (err: any) {
        if (dispatchNotification) {
          dispatch(
            notifyUser({
              showToast: true,
              toastMessage: 'Upload failed',
              toastType: 'failed',
            })
          );
        }

        if (err.response) {
          setError(err.response.data.message || 'Something went wrong');
        } else {
          setError(err.message || 'Something went wrong');
        }
      } finally {
        setisUpoading(false);
      }
    },
    [dispatch]
  );

  return { uploadedFile, isUploadSuccess, isUploading, error, uploadFile };
}
